import { makeStyles } from '@material-ui/core';
const useEditorPopupStyles = makeStyles({
  popup: {
    minHeight: '320px',
    borderRadius: '10px',
    width: '600px',
    border: '1px solid #E4E4E4',
    backgroundColor: '#fff',
    zIndex: 999999,
    cursor: 'default'
  },
  drag: {
    cursor: 'default',
  },
  header: {
    width: '100%',
    height: '24px',
    backgroundColor: '#E4E4E4',
    borderRadius: '10px 10px 0 0',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'move',
    marginTop: '',
    
  },
  defaultDrag:{
    "& div:last-child div":{
      cursor:"default !important"
    }
  }
});

export default useEditorPopupStyles;
